export default [
    {
      path: '/plans/containerWash/list',
      name: 'plans.containerWash.list',
      component: () => import('@/views/modules/plans/containerWash-plan/plan-list/PlansList'),
      meta: {
        module: 'plans.containerWash',
        pageTitle: 'CONTAINER_WASH_LIST_TITLE',
        breadcrumb: [],
      }
    },
    {
      path: '/plans/containerWash/create',
      name: 'plans.containerWash.create',
      component: () => import('@/views/modules/plans/containerWash-plan/create/CreatePlan'),
      meta: {
        module: 'plans.containerWash',
        pageTitle: 'Plan Create',
        breadcrumb: [
          { text: 'CONTAINER_WASH_LIST_TITLE', to: {name: 'plans.containerWash.list'} },
          { text: 'CONTAINER_WASH_CREATE_TITLE' , active: true}
        ],
      }
    },
  
  
    {
      path: '/plans/containerWash/:id/edit',
      name: 'plans.containerWash.edit',
      component: () => import('@/views/modules/plans/containerWash-plan/edit/EditPlan'),
      meta: {
        module: 'plans.containerWash',
        pageTitle: 'Edit Plan',
        breadcrumb: [
          { text: 'CONTAINER_WASH_LIST_TITLE', to: {name: 'plans.containerWash.list'} },
          { text: 'CONTAINER_WASH_EDIT_TITLE' , to: {name: 'plans.containerWash.edit'}},
         
        ],
      }
    },
  ]
  